import { render, staticRenderFns } from "./jobs-new.vue?vue&type=template&id=521b64c8&"
import script from "./jobs-new.vue?vue&type=script&lang=js&"
export * from "./jobs-new.vue?vue&type=script&lang=js&"
import style0 from "./jobs-new.vue?vue&type=style&index=0&id=521b64c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports